module.exports = __webpack_public_path__ + "static/img/bottomQrImg1.a6d3c3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottomQrImg1.jpg
// module id = /RJr
// module chunks = 1